import { TAutoCompleteOptions } from '../types';

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const month: TAutoCompleteOptions[] = [
  { key: 1, value: 1, label: 'January' },
  { key: 2, value: 2, label: 'February' },
  { key: 3, value: 3, label: 'March' },
  { key: 4, value: 4, label: 'April' },
  { key: 5, value: 5, label: 'May' },
  { key: 6, value: 6, label: 'June' },
  { key: 7, value: 7, label: 'July' },
  { key: 8, value: 8, label: 'August' },
  { key: 9, value: 9, label: 'September' },
  { key: 10, value: 10, label: 'October' },
  { key: 11, value: 11, label: 'November' },
  { key: 12, value: 12, label: 'December' },
];

export const startYear: number = new Date().getFullYear();

export const currentMonth: number = new Date().getMonth();

export const yearRange: TAutoCompleteOptions[] = [];

for (let i = 0; i < 25; i++) {
  yearRange.push({
    value: startYear - i,
    label: (startYear - i).toString(),
  });
}

const d = new Date();
export const currentMonthString = months[d.getMonth()];

export const calculateDateDifference = (
  startDate: string,
  endDate: string
) => {
  const parseDate = (dateStr: string): Date => {
    const [day, month, year] = dateStr
      .split('/')
      .map(Number);
    return new Date(year, month - 1, day);
  };

  const start: Date = parseDate(startDate);
  const end: Date = parseDate(endDate);

  // Difference in milliseconds
  const diffInMs = end.getTime() - start.getTime();

  // Convert to days, hours, minutes, seconds
  const diffInDays = Math.floor(
    diffInMs / (1000 * 60 * 60 * 24)
  );
  const diffInHours = Math.floor(
    (diffInMs / (1000 * 60 * 60)) % 24
  );
  const diffInMinutes = Math.floor(
    (diffInMs / (1000 * 60)) % 60
  );
  const diffInSeconds = Math.floor((diffInMs / 1000) % 60);

  return {
    days: diffInDays,
    hours: diffInHours,
    minutes: diffInMinutes,
    seconds: diffInSeconds,
  };
};

export const timeStampDiff = (
  timestamp1: number,
  timestamp2: number
) => {
  const ms1 = timestamp1 * 1000;
  const ms2 = timestamp2 * 1000;
  const differenceMs = Math.abs(ms1 - ms2);
  const differenceDays = Math.round(
    differenceMs / (1000 * 60 * 60 * 24)
  );

  return {
    differenceDays,
  };
};
